<div class="right-panel h-100 text-grey">
  <div class="right-side">
    <as-split direction="horizontal">
      <as-split-area [size]="detailsViewOpen ? 20 : 100">
        <div class="node-list">
          <div class="actionBar mt-0">
            <div class="flex-grow-1 d-flex gap-2">
              @if (showRescaleSlider() && scaleValue != null &&
              !detailsViewOpen) {
              <input
                     class="search p-2 w-25"
                     type="text"
                     placeholder="Search by name"
                     [(ngModel)]="nodesSearchText"
                     (ngModelChange)="applyFilter()"
                     />
              <div class="scaleUpDown flex-grow-1">
                <label class="fw-bold text-nowrap">Scale Up/Down : </label>
                <mat-slider
                            class="flex-grow-1"
                            [min]="0"
                            [max]="scaleMax"
                            [step]="scaleStepSize"
                            [discrete]="true"
                            [showTickMarks]="true"
                            >
                  <input
                         matSliderThumb
                         [value]="scaleValue"
                         (valueChange)="onValueChange($event)"
                         />
                  <!-- <input matSliderThumb> -->
                </mat-slider>
              </div>
              } @else {
              <input
                     class="search p-2"
                     type="text"
                     placeholder="Search by name"
                     [(ngModel)]="nodesSearchText"
                     (ngModelChange)="applyFilter()"
                     />
              }
            </div>
            <button
                    type="button"
                    class="actionBtn"
                    (click)="refreshComponent()"
                    placement="top auto"
                    container="body"
                    triggers="hover" ngbTooltip="Refresh Nodes"
                    >
              <span class="bi bi-arrow-clockwise"></span>
              <span class="button-animation">&nbsp;Refresh</span>
            </button>
            <ng-container *ngIf="!detailsViewOpen">
              <button
                      type="button"
                      class="actionBtn position-relative"
                      [ngbPopover]="filtersContent"
                      #filtersPopover="ngbPopover"
                      [autoClose]="'outside'"
                      popoverClass="filter-popover"
                      container="body"
                      placement="bottom"
                      (mouseenter)="tooltipInstance.open()"
                      (mouseleave)="tooltipInstance.close()"
                      [ngbTooltip]="'Show/Hide Filters'"
                      #tooltipInstance="ngbTooltip">
                <span class="bi bi-funnel"></span>
                <span class="position-absolute top-0 start-100 badge rounded-pill"
                      *ngIf="getActiveFiltersCount() > 0">
                  {{ getActiveFiltersCount() }}
                  <span class="visually-hidden">active filters</span>
                </span>
              </button>
              <button
                      class="actionBtn"
                      style="margin-left: 5px"
                      (click)="editColoum()"
                      triggers="hover" ngbTooltip="Edit Columns">
                <span>
                  <i
                     class="bi bi-sliders"
                     style="font-size: x-large; margin-right: 2px">
                  </i>
                </span>
              </button>
              <button
                      class="actionBtn"
                      style="
                  border: 1px solid var(--s-primary-color);
                  float: right;
                  font-size: 28px;
                "
                      (click)="openAttachNodeDialog()"
                      triggers="hover" ngbTooltip="Attach Existing VDI Nodes"
                      *ngIf="
                  isNotJobOperator && isMonitor == false && isCloudKVM == false
                "
                      >
                <span class="bi bi-node-plus"></span>
              </button>
              <button
                      class="actionBtn"
                      type="button"
                      container="body"
                      placement="top auto"
                      triggers="hover" ngbTooltip="Add Node"
                      style="border: 1px solid var(--s-primary-color); float: right"
                      title="Add New Node"
                      (click)="openAddNodeDialog()"
                      *ngIf="
                  isNotJobOperator && isMonitor == false
                "
                      >
                <span class="bi bi-diagram-3" style="font-size: larger"></span>
                <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
              </button>
              <button
                      class="actionBtn"
                      type="button"
                      container="body"
                      placement="top auto"
                      triggers="hover" ngbTooltip="Import existing KVM virtual machines"
                      style="border: 1px solid var(--s-primary-color); float: right"
                      title="Import existing KVM virtual machines"
                      (click)="syncKvmVms()"
                      *ngIf="
                  isNotJobOperator && isMonitor == false && isCloudKVM == true
                "
                      >
                <span class="bi bi-arrow-repeat" style="font-size: larger"></span>
                <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
              </button>
              <ng-select
                         name=""
                         id=""
                         #depActions
                         class="depActions"
                         [searchable]="false"
                         [(ngModel)]="actionValue"
                         (change)="deploymentActions($event)"
                         [clearable]="false"
                         *ngIf="isNotJobOperator && available && isMonitor == false"
                         >
                <ng-option value="0">Actions</ng-option>
                <ng-option value="6" *ngIf="isVdiDeployment && isCloudKVM == false"
                           >Detach Selected</ng-option
>
                <ng-option value="1" *ngIf="nodes && !autoScaleActive2">
                  Start All Nodes
                </ng-option>
                <ng-option value="2" *ngIf="nodes"> Stop All Nodes </ng-option>
                <ng-option value="{{ autoscaleValue }}" *ngIf="false">
                  Enable AutoScale
                </ng-option>
                <ng-option value="{{ autoscaleValue }}" *ngIf="false">
                  Disable AutoScale
                </ng-option>
              </ng-select>
            </ng-container>
          </div>

          <ng-template #filtersContent>
            <div class="filters-popover-content">
              <div class="filter-container text-grey">
                <div class="filter-section">
                  <label class="filter-label">Availability</label>
                  <div class="field-container">
                    <ng-select name="availability"
                               [(ngModel)]="filterAvailability"
                               (ngModelChange)="applyFilter()"
                               [clearable]="false"
                               [searchable]="false">
                      <ng-option value="All" [selected]="filterAvailability == 'All'">All Availability</ng-option>
                      <ng-option *ngFor="let availability of availabilityList"
                                 [value]="availability || 'NA'">
                        {{ availability ? availability : "NA" }}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="filter-section">
                  <label class="filter-label">Node Types</label>
                  <div class="field-container">
                    <ng-select name="nodetypes"
                               [(ngModel)]="filterNodetypes"
                               (ngModelChange)="applyFilter()"
                               [clearable]="false">
                      <ng-option value="All" [selected]="filterNodetypes == 'All'">All Nodes</ng-option>
                      <ng-option *ngFor="let nt of nodeTypes" value="{{ nt }}">{{ nt }}</ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="filter-section">
                  <label class="filter-label">States</label>
                  <div class="field-container">
                    <ng-select name="states"
                               [(ngModel)]="filterState"
                               (ngModelChange)="applyFilter()"
                               [clearable]="false">
                      <ng-option value="All" [selected]="filterState == 'All'">All States</ng-option>
                      <ng-option *ngFor="let state of vmStates" value="{{ state }}">{{ state }}</ng-option>
                    </ng-select>
                  </div>
                </div>

                <div class="filter-section">
                  <label class="filter-label">Platform</label>
                  <div class="field-container">
                    <ng-select name="platform"
                               [(ngModel)]="filterPlatform"
                               (ngModelChange)="applyFilter()"
                               [clearable]="false"
                               [searchable]="false">
                      <ng-option value="All" [selected]="filterPlatform == 'All'">All Platforms</ng-option>
                      <ng-option value="Windows">Windows</ng-option>
                      <ng-option value="Linux">Linux</ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <button type="button"
                          class="reset-button"
                          (click)="resetFilter()">
                    <span class="bi bi-x-lg reset-icon"></span>
                    Reset Filters
                  </button>
                  </div>
                </div>
              </div>
          </ng-template>
          <div
               class="listTable flex-grow-1"
               style="white-space: nowrap"
               *ngIf="available"
               >
            <div class="flex-grow-1">
              <table
                     class="table table-hover"
                     cellspacing="0"
                     style="border-collapse: collapse"
                     [ngStyle]="{ 'min-width': detailsViewOpen ? '90vw' : '100%' }"
                     dynamicPagination
                     [rowHeight]="32"
                     [offsetHeight]="200"
                     [paginationInstance]="config"
                     >
                <thead style="text-align: center exclude-text-grey">
                  <tr class="table-list-head">
                    <th class="selectAllCheckBox"
                        title="Select All"
                        resizable
                        (change)="onSelectAllCheckBox($event)">
                      <input type="checkbox" [checked]="isSelectAll" id="" />
                    </th>
                    <th scope="col" resizable>
                      <a style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        ">#</a>
                    </th>
                    <th scope="col" resizable>
                      <a style="
                          color: White;
                          text-decoration: none;
                          cursor: default;
                        ">Name</a>
                    </th>
                    <th scope="col" resizable>Node Type</th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('Cores')"
                        resizable>
                      Cores
                      <span (click)="sortCores(true)"
                            title="Sort Ascending/Descending"
                            [ngClass]="
  availabilitySort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
"
                            class="bi"></span>
                    </th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('Availability')"
                        resizable>
                      Availability
                      <span (click)="sortAvailability(true)"
                            title="Sort Ascending/Descending"
                            [ngClass]="
     availabilitySort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
   "
                            class="bi"></span>
                    </th>
                    <th scope="col"
                        *ngIf="
                        nodeListColumnToShow.includes('HPC Units') &&
                        showBilling
                      "
                        resizable>
                      HPC Units
                    </th>
                    <th scope="col"
                        *ngIf="
                        nodeListColumnToShow.includes('Billed Hrs') &&
                        showBilling
                      "
                        resizable>
                      Billed Hrs
                    </th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('State')"
                        resizable>
                      State
                    </th>
                    <th *ngIf="nodeListColumnToShow?.includes('SchedulerState')"
                        resizable
                        scope="col">
                      SchedulerState
                    </th>
                    <th *ngIf="nodeListColumnToShow?.includes('Node Group')"
                        resizable
                        scope="col">
                      Node Group
                    </th>
                    <th title="Allocated CPUs / Total CPUs"
                        *ngIf="nodeListColumnToShow.includes('Alloc/Total')"
                        resizable
                        scope="col">
                      Alloc/Total
                    </th>
                    <th scope="col" resizable title="Average usage of CPU">
                      CPU %
                      <span (click)="sortCPU(true)"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          cpuSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th scope="col" resizable title="Average usage of RAM">
                      RAM %
                      <span (click)="sortRAM(true)"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          ramSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('GPU %')"
                        resizable
                        title="Average usage of GPU">
                      GPU %
                      <span (click)="sortGPU(true)"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          gpuSort ? 'bi-arrow-up-short' : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('GPU Mem %')"
                        resizable
                        title="Average usage of GPU Memory">
                      GPU Mem %
                      <span (click)="sortGPUMemory(true)"
                            title="Sort Ascending/Descending"
                            [ngClass]="
                          gpuMemorySort
                            ? 'bi-arrow-up-short'
                            : 'bi-arrow-down-short'
                        "
                            class="bi"></span>
                    </th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('Network (Mb/sec)')"
                        resizable
                        title="Average usage of GPU Memory">
                      Network (Mb/sec)
                    </th>
                    <th scope="col"
                        *ngIf="nodeListColumnToShow.includes('Sessions')"
                        resizable>
                      Sessions
                    </th>
                    <th scope="col" resizable></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-list-row"
                      *ngFor="
                      let node of applyFilter()
                        | paginate
                          : { itemsPerPage: config.itemsPerPage, currentPage: config.currentPage };
                      let i = index
                    "
                      [ngClass]="{
                      highlightClickedRow:
                        this.selectedNode.vmName == node.vmName
                    }"
                      (click)="redirectTo(node, 7 * (config.currentPage - 1) + i)"
                      (dblclick)="toggleNodeView(node)">
                    <td>
                      <div>
                        <input type="checkbox"
                               title="Select File"
                               class="selectCheckbox"
                               (click)="checkSelectedCheckboxes($event, node.vmName)"
                               [checked]="multiSelectIndex.includes(node.vmName)" />
                      </div>
                    </td>
                    <td style="cursor: pointer" scope="row">
                      {{ 7 * (config.currentPage - 1) + (i + 1) }}
                    </td>
                    <td class="impListName" (click)="toggleNodeView(node)">
                      {{ node.vmName }}
                      <span matTooltip="This workstation has been reserved to specific users."
                            *ngIf="node.reserved"
                            class="logged-out">●</span>
                    </td>
                    <td #nodeTypeCell>
                      <div class="live-indicator-block"
                          *ngIf="node.nodeType === 'Host (HW)'">
                        <span class="host-badge">
                          {{ node.nodeType | shortenString : (nodeTypeCell.offsetWidth || 200) }}
                        </span>
                      </div>
                      <div *ngIf="node.nodeType != null && node.nodeType != '' && node.nodeType != 'Host (HW)'">
                        {{ node.nodeType | shortenString : (nodeTypeCell.offsetWidth || 200) }}
                      </div>
                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('Cores')">
                      {{node.cores}}
                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('Availability')">
                      {{ node.availability ? node.availability : "NA" }}
                    </td>
                    <td *ngIf="
                        nodeListColumnToShow.includes('HPC Units') &&
                        showBilling
                      "
                        title="{{ node.hpcUnitsUsed }}">
                      {{ node.hpcUnitsUsed }}
                    </td>
                    <td *ngIf="
                        nodeListColumnToShow.includes('Billed Hrs') &&
                        showBilling
                      "
                        title="{{ node.billedHours }}">
                      {{ node.billedHours }}
                    </td>
                    <td #stateCell
                        *ngIf="nodeListColumnToShow.includes('State')"
                        title="{{ node.state }}">
                      {{ node.state | shortenString : (stateCell.offsetWidth || 200) }}
                    </td>
                    <td #schedulerCell
                        *ngIf="nodeListColumnToShow?.includes('SchedulerState')"
                        title="{{ node.schedulerState }}">
                      {{ node.schedulerState || "NA" | shortenString : (schedulerCell.offsetWidth || 200) }}
                    </td>
                    <td *ngIf="nodeListColumnToShow?.includes('Node Group')">
                      @if(node.azureServiceName != null && node.azureServiceName != ''){
                      <select style="padding: 2px;">
                        <option *ngFor="let group of getDataOfNodeGroup(node)">{{group}}</option>
                      </select>
                      <!-- {{ node.azureServiceName || "NA" | shortenString : 180) }} -->
                      }@else
                      {
                      <span>NA</span>

                      }

                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('Alloc/Total')"
                        title="{{ node.allocTotal }}">
                      {{ node.allocTotal }}
                    </td>
                    <td>
                      <div class="progress"
                           style="width: 70%; margin-right: 5px; margin-left: 5px"
                           title="{{ node.cpuUsage }}%">
                        <div class="progress-bar"
                             role="progressbar"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             [style.width.%]="node.cpuUsage"></div>
                        <span class="progressValue"
                              [style.width.%]="node.cpuUsage">{{ node.cpuUsage }}%</span>
                      </div>
                    </td>
                    <td>
                      <div class="progress" title="{{ node.ramUsage }}%">
                        <div class="progress-bar"
                             role="progressbar"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             [style.width.%]="node.ramUsage"></div>
                        <span class="progressValue"
                              [style.width.%]="node.ramUsage">{{ node.ramUsage }}%</span>
                      </div>
                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('GPU %')">
                      <div class="progress" title="{{ node.gpuUsage }}%">
                        <div class="progress-bar"
                             role="progressbar"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             [style.width.%]="node.gpuUsage"></div>
                        <span class="progressValue"
                              [style.width.%]="node.gpuUsage">{{ node.gpuUsage || 0 }}%</span>
                      </div>
                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('GPU Mem %')">
                      <div class="progress" title="{{ node.gpuMemoryUsage }}%">
                        <div class="progress-bar"
                             role="progressbar"
                             aria-valuemin="0"
                             aria-valuemax="100"
                             [style.width.%]="node.gpuMemoryUsage"></div>
                        <span class="progressValue"
                              [style.width.%]="node.gpuMemoryUsage">{{ node.gpuMemoryUsage || 0 }}%</span>
                      </div>
                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('Network (Mb/sec)')">
                      {{ node.networkUsage }}
                    </td>
                    <td *ngIf="nodeListColumnToShow.includes('Sessions')">
                      <select name="" class="w-75" id="" style="outline: none">
                        <option *ngFor="let session of node.sessions; let n = index">
                          {{ n + 1 }}. {{ session }}
                        </option>
                      </select><span class="ms-2 bi bi-arrow-right-square fs-6"
                                     (click)="goToSession()"></span>
                    </td>
                    <td class="actionsNode">
                      <div *ngIf="node?.state != 'Unassigned'">
                        <div class="btn-group"
                             ngbDropdown
                             container="body"
                             role="group"
                             aria-label="Button group with nested dropdown">
                          <i title="Node actions"
                             class="btn dropdown-toggle-split bi bi-three-dots p-0 border-0 bg-transparent synchpc-primary"
                             ngbDropdownToggle></i>
                          <div class="dropdown-menu" ngbDropdownMenu>
                            <button ngbDropdownItem
                                    *ngFor="let action of node.actionsAvl"
                                    (click)="nodeAction(action, node)"
                                    [title]="action.title"
                                    [class.disabled]="action.disabled">
                              <i class="bi"
                                 [ngClass]="action.icon"
                                 style="color: var(--s-primary-color)"></i>
                              &nbsp;<span class="fs-6 text-dark"
                                          style="font-size: 13px !important">{{ action.name }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex mt-1 " *ngIf="available === true">
              <!-- <div
        style="display: flex; align-items: center"
        *ngIf="!jobViewOpen"
      >
        <input
          class="pagination-input"
          placeholder="Entries Per Page"
          type="number"
          [value]="nodeNumberToShow"
          (change)="paginationEntries($event)"
          style="border: 1px solid var(--bs-blue); padding-left: 0.6rem"
          matTooltip="Entries per page"
        />
        <button
          class="dataTransferBtns"
          style="
            border: 1px solid var(--bs-blue);
            border-left: none;
            background-color: white;
          "
          (click)="showAllEntriesMethod($event)"
        >
          Go
        </button>
      </div> -->
              <pagination-controls
                                   class="my-pagination"
                                   autoHide="true"
                                   (pageBoundsCorrection)="config.currentPage = $event"
                                   (pageChange)="config.itemsPerPage = $event"
                                   ></pagination-controls>
            </div>
          </div>

          <p id="emptyError" *ngIf="available === false">
            No Nodes are available for selected deployment
          </p>
        </div>
      </as-split-area>
      <as-split-area
        [size]="detailsViewOpen ? 80 : 0"
        *ngIf="detailsViewOpen"
        [minSize]="60"
      >
        <div class="h-100 mx-1 px-1 advanceDetails">
          <app-node-advance-view
            (hideDetails)="hideJobDetails()"
          ></app-node-advance-view>
        </div>
      </as-split-area>
    </as-split>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="nodeList"
  >
    <p class="pleaseWait">Please wait ...</p>
  </ngx-spinner>
</div>
<ng-template #htmlContentTooltip>
  <div
    *ngIf="tooltipHtml"
    class="tooltipNodeName"
    [innerHTML]="tooltipHtml | safeHtml"
  ></div>
</ng-template>
